import type { LoaderFunction } from 'react-router-dom';
import { apiListPpvByPage, apiListPpvByYear } from '../components/ui_components/ApiList';

// Funzione per rilevare se siamo in modalita mobile senza hook
const isMobileScreen = (): boolean => {
    if (typeof window === 'undefined') {
        return false; // Server-side rendering fallback
    }
    return window.innerWidth < 768;
};

export const ListPpvResponsiveLoader: LoaderFunction = async () => {
    try {
        // Rileva se siamo in modalita mobile
        const isMobile = isMobileScreen();

        if (isMobile) {
            // Carica dati mobile
            const resListPpvData = await apiListPpvByPage(1);
            const resListPpvDataByYear = await apiListPpvByYear();

            return {
                listPpv: resListPpvData,
                listPpvByYear: resListPpvDataByYear
            };
        } else {
            // Carica dati desktop
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'api/ppv/list?page=1');
            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            const resData = await response.json();
            return resData;
        }
    } catch (error) {
        console.error('Loader error:', error);
        throw new Error('Failed to load data');
    }
};
